module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.bg),
    attrs: {
      "id": "app"
    }
  }, [_c('ahead'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('presentation'), _vm._v(" "), _vm._l((_vm.articles), function(article) {
    return [_c('categories', {
      attrs: {
        "item": article
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ca3b50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 24
// module chunks = 0